var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "purchase", attrs: { id: "purchase" } },
    [
      _vm.fetching
        ? [
            _c("spinner", {
              attrs: {
                message: "Kaufoptionen werden geladen…",
                margin: "50px auto",
              },
            }),
          ]
        : [
            _vm._m(0),
            _vm._v(" "),
            _c("section", { staticClass: "purchase__options" }, [
              !_vm.articleData.loggedIn
                ? _c(
                    "div",
                    { staticClass: "purchase__option purchase__option--login" },
                    [
                      _vm._m(1),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "purchase__button",
                          attrs: { href: _vm.loginUrl, rel: "nofollow" },
                        },
                        [
                          _vm._v(
                            "\n            Anmelden und Artikel sofort lesen\n          "
                          ),
                        ]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.freeTrial
                ? _c(
                    "div",
                    {
                      staticClass:
                        "purchase__option purchase__option--free-trial",
                    },
                    [
                      _c(
                        "h1",
                        { staticClass: "purchase__option-header" },
                        [
                          _vm.articleData.magazineDbName === "ct"
                            ? [
                                _vm._v(
                                  "\n            Artikel freischalten +  2 aktuelle Ausgaben c't GRATIS lesen\n          "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n            Anmelden und zwei Monate GRATIS testen\n          "
                                ),
                              ],
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("section", { staticClass: "free-trial__container" }, [
                        _c("div", { staticClass: "free-trial__image" }, [
                          _c("img", {
                            staticClass: "purchase__thumbnail",
                            attrs: {
                              src:
                                "/scale/geometry/212/q75" +
                                _vm.freeTrial.thumbnail,
                              alt: "Artikelvorschau",
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c(
                          "section",
                          { staticClass: "free-trial__content" },
                          [
                            _c(
                              "ul",
                              { staticClass: "purchase__benefits" },
                              _vm._l(
                                _vm.freeTrial.benefits,
                                function (benefit) {
                                  return _c(
                                    "li",
                                    {
                                      key: benefit,
                                      staticClass: "purchase__benefit",
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(benefit) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                            _vm._v(" "),
                            _vm.articleData.magazineDbName === "ct"
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "purchase__benefits__info" },
                                    [
                                      _vm._v(
                                        "*für iOS, Android und Kindle Fire"
                                      ),
                                    ]
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "a",
                              {
                                staticClass:
                                  "purchase__button purchase__button--pay",
                                attrs: {
                                  href: _vm.freeTrial.url,
                                  rel: "nofollow",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              Jetzt GRATIS testen\n            "
                                ),
                              ]
                            ),
                          ],
                          2
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "purchase__option purchase__option--issue" },
                [
                  _c(
                    "section",
                    { staticClass: "purchase__option-header-container" },
                    [
                      _c("h1", { staticClass: "purchase__option-header" }, [
                        _vm._v("\n            Heft kaufen\n          "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "purchase__option-text" },
                        [
                          _vm._v("\n            Sie können\n            "),
                          _vm.articleData.magazineDbName === "ch"
                            ? [_vm._v("\n              das\n            ")]
                            : [_vm._v("\n              die\n            ")],
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.articleData.magazineScreenName) +
                              "\n            "
                          ),
                          _vm.issue.url
                            ? [
                                _vm._v(
                                  "\n              als PDF oder\n            "
                                ),
                              ]
                            : _vm._e(),
                          _vm._v(
                            "\n            als gedrucktes Heft kaufen.\n          "
                          ),
                        ],
                        2
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("img", {
                    staticClass: "purchase__thumbnail",
                    attrs: {
                      src:
                        "/scale/geometry/212/q75" +
                        "/select/thumbnail/" +
                        _vm.articleData.magazine +
                        "/" +
                        _vm.articleData.issueYear +
                        "/" +
                        _vm.articleData.issueNumber,
                      alt: "Titelbild",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "purchase__button-container" }, [
                    _vm.articleData.shopUrl && _vm.issue.price
                      ? _c(
                          "form",
                          {
                            attrs: {
                              id: "buy_pdf",
                              method: "POST",
                              action: _vm.articleData.shopUrl,
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "success_url" },
                              domProps: { value: _vm.articleData.url },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "purchase__button purchase__button--pay",
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n              Heft digital kaufen - " +
                                    _vm._s(_vm.issue.price) +
                                    "€\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.issue.url &&
                    _vm.issue.print &&
                    _vm.issue.print.soldOut !== true
                      ? _c(
                          "form",
                          {
                            attrs: {
                              id: "buy_print",
                              method: "POST",
                              action: _vm.articleData.shopPrintUrl,
                            },
                          },
                          [
                            _c("input", {
                              attrs: { type: "hidden", name: "success_url" },
                              domProps: { value: _vm.articleData.url },
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "purchase__button purchase__button--pay",
                                attrs: { type: "submit" },
                              },
                              [
                                _vm._v(
                                  "\n              Heft kaufen - " +
                                    _vm._s(_vm.issue.print.price) +
                                    "€\n            "
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.issue.url &&
                    _vm.issue.print &&
                    _vm.issue.print.soldOut === true
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "purchase__no__purchase issue__special__info",
                            attrs: { id: "buy_print" },
                          },
                          [
                            _vm._v(
                              "\n            Dieses Heft ist nicht gedruckt erwerbbar.\n          "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.upsell
                ? _c(
                    "div",
                    {
                      staticClass: "purchase__option purchase__option--upsell",
                    },
                    [
                      _vm._m(2),
                      _vm._v(" "),
                      _c("img", {
                        staticClass: "purchase__thumbnail",
                        attrs: {
                          src: "/scale/geometry/212/q75" + _vm.upsell.thumbnail,
                          alt: "Artikelvorschau",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "purchase__option purchase__option--heiseplus" },
                [
                  _c("div", { staticClass: "heiseplus__container" }, [
                    _c(
                      "svg",
                      {
                        staticClass: "heiseplus-header__logo",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          viewBox: "0 0 78 24",
                          role: "img",
                          preserveAspectRatio: "xMinYMin",
                          width: "156",
                          height: "48",
                        },
                      },
                      [
                        _c("title", [_vm._v("heise+")]),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M52.04 24H1.96a1.92 1.92 0 0 1-1.92-1.92V1.92C.04.86.9 0 1.96 0h50.08v24Z",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M5.41 4.9h2.21v3.5l-.09 1.82c.79-.74 1.72-1.42 3.01-1.42 2.01 0 2.89 1.36 2.89 3.74v5.9h-2.21v-5.61c0-1.55-.44-2.13-1.46-2.13-.83 0-1.37.41-2.14 1.17v6.57H5.41V4.9Zm10.06 8.83c0 3.1 2.04 4.93 4.63 4.93 1.19 0 2.33-.41 3.22-1.02l-.75-1.37c-.69.43-1.38.68-2.18.68-1.52 0-2.59-.95-2.77-2.62h5.97c.05-.23.1-.65.1-1.07 0-2.63-1.34-4.47-3.88-4.47-2.21 0-4.33 1.88-4.33 4.94Zm6.31-.9H17.6c.19-1.51 1.16-2.33 2.25-2.33 1.29 0 1.93.88 1.93 2.33Zm3.76-6.7c0 .73.58 1.25 1.36 1.25s1.36-.52 1.36-1.25-.58-1.25-1.36-1.25-1.36.51-1.36 1.25Zm.25 2.9v9.4H28v-9.4h-2.21Zm4.08 8.33c.92.76 2.28 1.31 3.56 1.31 2.37 0 3.65-1.3 3.65-2.92 0-1.75-1.42-2.37-2.7-2.84-1.02-.37-1.97-.66-1.97-1.4 0-.59.45-1.04 1.39-1.04.74 0 1.4.34 2.06.82l1.01-1.35c-.77-.59-1.82-1.13-3.12-1.13-2.11 0-3.42 1.18-3.42 2.81s1.41 2.28 2.64 2.74c1 .38 2.02.73 2.02 1.52 0 .64-.48 1.13-1.51 1.13-.95 0-1.76-.4-2.6-1.05l-1.03 1.4Zm8.57-3.62c0 3.1 2.04 4.93 4.63 4.93 1.19 0 2.33-.41 3.22-1.02l-.75-1.37c-.69.43-1.38.68-2.18.68-1.52 0-2.59-.95-2.77-2.62h5.97c.05-.23.1-.65.1-1.07 0-2.63-1.34-4.47-3.88-4.47-2.21 0-4.33 1.88-4.33 4.94Zm6.31-.9h-4.18c.19-1.51 1.16-2.33 2.25-2.33 1.29 0 1.93.88 1.93 2.33Z",
                            fill: "#fff",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M53.99.01h22c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2h-22v-24Z",
                            fill: "#1b3f8f",
                          },
                        }),
                        _c("path", {
                          attrs: {
                            d: "M65.98 4.19c.78 0 1.42.64 1.42 1.42v12.82c0 .78-.64 1.42-1.42 1.42s-1.42-.64-1.42-1.42v-4.98h-4.98a1.43 1.43 0 1 1 0-2.86h4.98V5.61c0-.78.63-1.42 1.42-1.42Zm6.4 6.4h-2.83a1.43 1.43 0 1 0 0 2.86h2.83a1.43 1.43 0 1 0 0-2.86Z",
                            fill: "#fff",
                          },
                        }),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c("p", { staticClass: "heiseplus-header__text" }, [
                      _vm._v(
                        "\n            Magazin-Abonnenten erhalten heise+ zum Vorzugspreis.\n          "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "heiseplus-stage-purchase__button-area" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "purchase__button purchase__button--pay purchase__button--single",
                          attrs: { href: _vm.articleData.checkoutUrl },
                        },
                        [_vm._v("heise+ Abo abschließen")]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._m(4),
                ]
              ),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "purchase__header" }, [
      _c("h3", { staticClass: "purchase__teaser" }, [
        _vm._v("Sie wollen wissen, wie es weitergeht?"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "purchase__option-header-container" }, [
      _c("h1", { staticClass: "purchase__option-header" }, [
        _vm._v("\n            Login\n          "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "purchase__option-text" }, [
        _vm._v(
          "\n            Sie sind Abonnent?\n            Bitte loggen Sie sich hier ein.\n          "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("section", { staticClass: "purchase__option-header-container" }, [
      _c("h1", { staticClass: "purchase__option-header" }, [
        _vm._v("\n            Upsell\n          "),
      ]),
      _vm._v(" "),
      _c("p", {
        staticClass: "purchase__option-text",
        attrs: { "v.-html": "upsell.description" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      {
        staticClass:
          "purchase__option-header heiseplus-slogan heiseplus-header__slogan",
      },
      [
        _c("span", { staticClass: "heiseplus-header__subslogan" }, [
          _vm._v("\n              Immer mehr Wissen.\n            "),
        ]),
        _vm._v(
          "\n            Das digitale Abo für IT und Technik.\n          "
        ),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "heiseplus-stage-purchase__link-area" }, [
      _c(
        "a",
        {
          staticClass: "heiseplus-stage-purchase__link",
          attrs: { href: "/plus/info-faq/" },
        },
        [_vm._v("\n            Das ist heise+\n          ")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }